import React, { Component } from 'react'
import ReactTable from 'react-table';
import { formatAmount } from '../../../common/utils'

export default class taxSavingReport extends Component {

  formatEmptyAmount = (amount) => {
    let formattedAmount = amount ? formatAmount(amount, false, true, false) : '-';
    return formattedAmount
  }

  render() {
    const { taxSavingReport } = this.props.employeeData;
    const taxSavingReport1 = taxSavingReport && taxSavingReport.length > 0 && taxSavingReport.map(function (value, index, arr) {
      if (index === 0) value["firstRow"] = true
      else {
        value["firstRow"] = arr[index - 1].EmployeeId !== arr[index].EmployeeId;
      }
      return value;
    });
    const columns = [
      {
        Header: "Employee",
        accessor: "EmployeeName",
        // width: 120,
        className: "header-class table-border",
      },
      {
        Header: "Category",
        accessor: "TaxCategoryCode",
        width: 65,
        className: "header-class table-border align-right",
        headerStyle: { textAlign: 'right', fontSize: '13px' }
      },
      {
        Header: 'Total',
        headerStyle: { textAlign: 'center', marginLeft: '10px' },
        columns: [
          {
            Header: "Rec Amt",
            accessor: "TotalAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          },
          {
            Header: "Pending",
            accessor: "TotalRecAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          }
        ]
      },
      {
        Header: 'Apr',
        headerStyle: { textAlign: 'center' },
        columns: [
          {
            Header: 'Rec Amt',
            accessor: "AprAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          },
          {
            Header: 'Pending',
            accessor: "AprRecAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          }
        ]
      },
      {
        Header: 'May',
        headerStyle: { textAlign: 'center' },
        columns: [
          {
            Header: 'Rec Amt',
            accessor: "MayAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          },
          {
            Header: 'Pending',
            accessor: "MayRecAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          }
        ]
      },
      {
        Header: 'Jun',
        headerStyle: { textAlign: 'center' },
        columns: [
          {
            Header: 'Rec Amt',
            accessor: "JunAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          },
          {
            Header: 'Pending',
            accessor: "JunRecAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          }
        ]
      },
      {
        Header: 'Jul',
        headerStyle: { textAlign: 'center' },
        columns: [
          {
            Header: 'Rec Amt',
            accessor: "JulAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          },
          {
            Header: 'Pending',
            accessor: "JulRecAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          }
        ]
      },
      {
        Header: 'Aug',
        headerStyle: { textAlign: 'center' },
        columns: [
          {
            Header: 'Rec Amt',
            accessor: "AugAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          },
          {
            Header: 'Pending',
            accessor: "AugRecAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          }
        ]
      },
      {
        Header: 'Sep',
        headerStyle: { textAlign: 'center' },
        columns: [
          {
            Header: 'Rec Amt',
            accessor: "SepAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          },
          {
            Header: 'Pending',
            accessor: "SepRecAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          }
        ]
      },
      {
        Header: 'Oct',
        headerStyle: { textAlign: 'center' },
        columns: [
          {
            Header: 'Rec Amt',
            accessor: "OctAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          },
          {
            Header: 'Pending',
            accessor: "OctRecAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          }
        ]
      },
      {
        Header: 'Nov',
        headerStyle: { textAlign: 'center' },
        columns: [
          {
            Header: 'Rec Amt',
            accessor: "NovAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          },
          {
            Header: 'Pending',
            accessor: "NovRecAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          }
        ]
      },
      {
        Header: 'Dec',
        headerStyle: { textAlign: 'center' },
        columns: [
          {
            Header: 'Rec Amt',
            accessor: "DecAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          },
          {
            Header: 'Pending',
            accessor: "DecRecAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          }
        ]
      },
      {
        Header: 'Jan',
        headerStyle: { textAlign: 'center' },
        columns: [
          {
            Header: 'Rec Amt',
            accessor: "JanAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          },
          {
            Header: 'Pending',
            accessor: "JanRecAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          }
        ]
      },
      {
        Header: 'Feb',
        headerStyle: { textAlign: 'center' },
        columns: [
          {
            Header: 'Rec Amt',
            accessor: "FebAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          },
          {
            Header: 'Pending',
            accessor: "FebRecAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          }
        ]
      },
      {
        Header: 'Mar',
        headerStyle: { textAlign: 'center' },
        columns: [
          {
            Header: 'Rec Amt',
            accessor: "MarAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          },
          {
            Header: 'Pending',
            accessor: "MarRecAmount",
            Cell: props => <span>{this.formatEmptyAmount(props.value)}</span>,
            width: 60,
            className: "header-class table-border align-right",
            headerStyle: { textAlign: 'right', fontSize: '13px' }
          }
        ]
      }
    ]
    return (
      <>
        {taxSavingReport1 && taxSavingReport1.length > 0 &&
          <div className='row'>
            <div id="TaxSavingReportContainer" className="container-fluid" style={{ marginBottom: 20 }}>
              <ReactTable className="-highlight IRTable"
                columns={columns}
                data={taxSavingReport1}
                showPagination={false}
                pageSize={taxSavingReport1.length}
                sortable={false}
                getTrProps={(state, rowInfo, column, instance) => {
                  // console.log('state rowInfo column instance', state, rowInfo, column, instance)
                  return {
                    className: rowInfo && rowInfo.original.firstRow && 'first-row',
                    // style: {
                    //   backgroundColor: `${rowInfo && rowInfo.original.ColorCode}`, //this.getRandomColor(rowInfo.original.EmployeeId),
                    // }
                  }
                }}
                getTableProps={() => {
                  return {
                    style: { fontSize: '13px' }
                  }
                }}
                getTdProps={() => {
                  return {
                    style: { fontSize: '13px' }
                  }
                }}
              />
            </div>
          </div>
        }
      </>

    )
  }
}
